(function( $ ) {
  'use strict';

  function toggleAccordion(label) {
    // Only target this accordion-row
    var row = $(label).closest(".row.accordion-row");
    if ($(label).hasClass("active")) {
      $(label).removeClass("active");
      $(label).next(".content.active").removeClass("active").slideUp();
      $(label).find("span.chevron").removeClass("rotate");
    }
    else {
      $(row).find(".accordion .label.active").removeClass("active")
        .find(".chevron").removeClass("rotate");
      $(row).find(".accordion .content.active").removeClass("active").slideUp();
      $(label).addClass("active");
      $(label).next(".content").stop().slideToggle().addClass("active");
      $(label).find("span.chevron").addClass("rotate");
    }
  }

  $(window).load(function() {
    // Array of all accordion-rows
    const accordionRows = $(".accordion-row");
    $.each(accordionRows, function(i, row) {
      $(row).find(".accordion .content").hide();

      if (!$(row).hasClass("no-init-toggle")) {
        const firstLabel = $(row).find(".accordion .label").first();
        if (!!firstLabel) {
          toggleAccordion(firstLabel);
        }
      }
    });

    $(".accordion .label").click( function() {
      toggleAccordion(this)
    });
  })
})( jQuery );
